import { Controller } from "react-hook-form";
// ** Third Party
import Proptypes from "prop-types";
import classnames from "classnames";
import { generateRandomString } from "../../../utility/helpers/utils";

function RadioField (props) {
  const {
    icon,
    label,
    name,
    disabled = false,
    control,
    id,
    className = "mb-3",
    customOnChange = () => {}
  } = props;

  const tempId = `${generateRandomString(4)}_${id}`?.replace(/[\s()\-/]/g, "");

  return (
    <>
      <Controller
        control={control}
        id={id}
        name={name}
        render={({ field: { value, onChange } }) => {
          return (
            <div
              className={classnames("relative gap-2", {
                [className]: className
              })}
            >
              <input
                data-cy={`${id}-${name}`}
                name={name}
                id={tempId}
                onChange={(e) => {
                  onChange(e);
                  if (customOnChange) {
                    customOnChange(e.target.value);
                  }
                }}
                type="radio"
                className="absolute left-[11px] top-[7px] h-4 w-4 rounded-full border-gray-300 text-primary focus:ring-primary"
                value={id}
                checked={value === id}
                disabled={disabled}
              />
              {label && (
                <label
                  htmlFor={tempId}
                  data-cy={`label-${id}`}
                  className={classnames(
                    "relative flex min-h-[35px] w-full cursor-pointer select-none items-center rounded border py-1.5 pl-12 pr-4",
                    value === id
                      ? "border-secondary bg-secondary/70 text-white"
                      : "border-gray-300 bg-white hover:bg-gray-50",
                    {
                      "cursor-not-allowed border-gray-300 bg-gray-300/40":
                        disabled
                    }
                  )}
                >
                  {label}
                </label>
              )}
            </div>
          );
        }}
      />
      {icon && <i className={icon} />}
    </>
  );
}

export default RadioField;

RadioField.propTypes = {
  errors: Proptypes.object,
  label (props, propName) {
    // ** If label is defined and htmlFor is undefined throw error
    if (props[propName] && props["htmlFor"] === "undefined") {
      throw new Error("htmlFor prop is required when label prop is present");
    }
  },
  id            : Proptypes.string.isRequired,
  icon          : Proptypes.string,
  name          : Proptypes.string.isRequired,
  disabled      : Proptypes.bool,
  control       : Proptypes.any.isRequired,
  className     : Proptypes.string,
  customOnChange: Proptypes.func
};
